module.exports = __webpack_public_path__ + "images/register/step4-icon.5a5cd71c.svg";